import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";

const ResumeUpload = ({
  onFileSelected, // what to do when a file is selected
  resumeFile, // the selected resume file
  onFileDownload, // what to do when user clicks to DL resume
  handlePreview,
  variant = "body1",
  fileName, // the name of resume file already uploaded by user (if applicable)
  isEditing, // is edit window open
  isDownloading,
  deleteResume, // did user click to delete resume
}) => {
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      onFileSelected(selectedFile);
    }
  };

  return isEditing ? (
    <Box
      sx={{
        mt: 2,
        p: 3,
        border: "1px dashed grey",
        textAlign: "center",
        width: "100%",
        minHeight: "150px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxSizing: "border-box",
        borderRadius: 1,
        backgroundColor: "rgba(255, 255, 255, 0.05)",
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        {resumeFile ? resumeFile?.name : fileName || "Upload Resume (PDF/DOCX)"}
      </Typography>
      <Box>
        {/* File Selector Button */}
        <Button
          variant="outlined"
          component="label"
          size="small"
          sx={{ color: "white", borderColor: "grey.500" }}
        >
          {"Select File"}
          <input
            type="file"
            hidden
            onChange={handleFileChange}
            accept=".pdf,.docx"
          />
        </Button>
        {/* Action Button: Delete or Upload */}
        {fileName && (
          <Button
            onClick={() => onFileSelected(null)}
            sx={{ ml: 2 }}
            variant="contained"
            size="small"
          >
            Remove Resume
          </Button>
        )}
      </Box>
      {deleteResume && (
        <Typography variant="body2" sx={{ mt: 1, color: "error.main" }}>
          Resume will be deleted if you do not select a new one
        </Typography>
      )}
    </Box>
  ) : (
    /* View Mode */
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1.5,
        "& .MuiBox-root": {
          mr: 0,
          width: "100%",
        },
      }}
    >
      <Box
        sx={{
          width: "160px",
          minWidth: "160px",
          textAlign: "center",
          mr: 4,
        }}
      >
        <Typography
          variant={variant}
          sx={{
            fontWeight: "bold",
            textDecoration: "underline",
            whiteSpace: "nowrap",
          }}
        >
          Resume:
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        {resumeFile?.name || fileName ? (
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1.5}
            sx={{ mt: 1, width: "100%" }}
          >
            <Button
              onClick={onFileDownload}
              startIcon={
                isDownloading && <CircularProgress size={16} color="inherit" />
              }
              sx={{
                color: "#90caf9",
                textDecoration: "underline",
                textTransform: "none",
                fontWeight: "normal",
                padding: 0,
                paddingY: 0,
                lineHeight: 1.2,
                fontSize: "1rem",
                minHeight: 0,
                "&:hover": {
                  textDecoration: "underline",
                  backgroundColor: "transparent",
                },
                "&.Mui-disabled": {
                  color: "grey.600",
                },
              }}
            >
              {resumeFile ? resumeFile?.name : fileName || "No file selected"}
            </Button>
            <Button
              onClick={() => handlePreview()}
              sx={{
                textTransform: "none",
                fontSize: "0.75rem",
                paddingY: "2px",
              }}
              variant="contained"
              size="small"
            >
              Preview
            </Button>
          </Stack>
        ) : (
          <Typography
            variant={variant}
            sx={{ width: "100%", textAlign: "center" }}
          >
            No resume uploaded
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ResumeUpload;
